import React from 'react';
import { Link } from 'react-router-dom';

function Hero({ subject }) {
  return (
    <section className="hero">
      <h1 className="hero-title">
        Draw something every day.
      </h1>
      <p className="hero-tagline">
        A new subject each morning. A community of doodlers.
        One small creative habit at a time.
      </p>
      {subject && (
        <p className="hero-subject">
          Today's subject: <strong>{subject}</strong>
        </p>
      )}
      <Link to="/?canvas=1" className="hero-cta">Start Drawing</Link>
    </section>
  );
}

export default Hero;
